<template>
  <div style="width: 100%">
    <v-row id="organization-chart" class="justify-center ma-2">
      <organization-chart
        class="organization"
        :dados="graficosUnidades.organization.dados"
        :fonte="`Sistema Desenvolva, ${anoMapeamento}`"
        :nos="graficosUnidades.organization.nos"
        :titulo="`Equipe da ${unidade.sigla}`"
      />
    </v-row>
    <v-row
      v-if="graficosUnidadesHierarquia.network.nos.length > 1"
      id="network-chart"
      class="justify-center ma-2"
    >
      <network-chart
        :dados="graficosUnidadesHierarquia.network.dados"
        :fonte="`Sistema Desenvolva, ${anoMapeamento}`"
        :nos="graficosUnidadesHierarquia.network.nos"
        :titulo="`${unidade.sigla} - Unidades Vinculadas`"
        class="network"
      />
    </v-row>
    <v-row>
      <v-col>
        <app-sort v-model="opcoes" />
      </v-col>

      <v-spacer />

      <v-col>
        <app-search v-model="opcoes" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="relatorio.participantes"
          :search="opcoes.pesquisa"
          :sort-by="opcoes.ordenarPor"
          :sort-desc="opcoes.decrescente"
          align-content-space-between
          class="elevation-0"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.cargo`]="{ item }">
            {{ item.cargo ? item.cargo : "N/D" }}
          </template>
          <template v-slot:[`item.funcao`]="{ item }">
            {{ item.funcao ? item.funcao : "N/D" }}
          </template>
          <template v-slot:footer>
            <v-row class="pa-4">
              <span class="body-2 secondary--text">
                <strong>* N/D -</strong> Informação não disponível
              </span>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Relatório PDF -->
    <v-row
      class="justify-end mb-1"
    >
      <v-tooltip
        max-width="400"
        top
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="success"
            @click="getRelatorio()"
            v-on="on"
          >
            <v-icon>get_app</v-icon>
            BAIXAR PDF
          </v-btn>
        </template>
        <span>Clique para baixar o relatório dos dados em formato PDF.</span>
      </v-tooltip>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OrganizationChart from '@/components/chart/OrganizationChart';
import NetworkChart from '@/components/chart/NetworkChart';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { generatePDF, getCanvas } from '@/modules/relatorioPDF';

export default {
  name: 'MonitoramentoUnidadesMapeamentoOrganograma',

  components: {
    OrganizationChart,
    NetworkChart,
    AppSort,
    AppSearch,
  },

  props: {
    mapeamento: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        { text: 'SERVIDOR', value: 'nome', sortable: false },
        {
          text: 'UNIDADE',
          value: 'siglaUnidade',
          align: 'center',
          sortable: false,
        },
        {
          text: 'CARGO',
          value: 'cargo',
          align: 'center',
          sortable: false,
        },
        {
          text: 'FUNÇÃO',
          value: 'funcao',
          align: 'center',
          sortable: false,
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nome',
        selecionado: { id: 'nome', descricao: 'Servidor' },
        lista: [
          { id: 'nome', descricao: 'Servidor' },
          { id: 'cargo', descricao: 'Cargo' },
          { id: 'funcao', descricao: 'Função' },
        ],
      },
    };
  },

  computed: {
    ...mapState({
      graficosUnidades: (state) => state.monitoramento.mapeamento.graficosUnidades,
      graficosUnidadesHierarquia: (state) => state.monitoramento.mapeamento.graficosUnidadesHierarquia,
      relatorios: (state) => state.monitoramento.mapeamento.relatorios,
      unidade: (state) => state.monitoramento.mapeamento.unidade,
    }),
    anoMapeamento() {
      return this.mapeamento.ano ? this.mapeamento.ano : '';
    },
    relatorio() {
      const relatorio = this.relatorios.find((r) => r.unidade.id === this.unidade.id);
      return relatorio || {};
    },
  },

  methods: {
    async getRelatorio() {
      const documento = {
        nome: 'relatorio-unidades-participantes',
        cabecalho: {
          titulo: 'Relatório de Unidades Participantes',
          itens: [
            `Unidade: ${this.unidade.sigla}`,
            `Mapeamento: ${this.mapeamento.nome}`,
          ],
        },
        blocos: [
          {
            titulo: '',
            subtitulo: '',
            itens: [
              { tipo: 'imagem', valor: await getCanvas('#organization-chart') },
            ],
          },
          this.graficosUnidadesHierarquia.network.nos.length > 1 ? {
            titulo: '',
            subtitulo: '',
            itens: [
              { tipo: 'imagem', valor: await getCanvas('#network-chart') },
            ],
          } : {},
          {
            titulo: '',
            subtitulo: '',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: [
                  'SERVIDOR',
                  'UNIDADE',
                  'CARGO',
                  'FUNÇÃO',
                ],
                linhas: this.relatorio.participantes.map((p) => ([
                  p.nome,
                  p.siglaUnidade,
                  p.cargo,
                  p.funcao ? p.funcao : 'N/D',
                ])),
              },
            }],
          },
        ],
      };
      generatePDF(documento);
    },
  },
};
</script>

<style scoped>
.network {
  width: 50%;
}

.organization {
  width: 50%;
}
</style>
